module.exports = __webpack_public_path__ + "img/btn-reformer@2x.fa775819.png";